export default __webpack_public_path__ + "static/media/CalenderIcon.03a0d3b1.svg";